<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      default: "1em"
    }
  },
  computed: {
    popoverText() {
      return this.value
        ? "Есть прикрепленные пользователи"
        : "Нет прикрепленных пользователей";
    }
  }
};
</script>

<template>
  <el-tooltip effect="dark" :content="popoverText" placement="top-start">
    <i
      v-if="value"
      :style="`font-size: ${size};`"
      class="el-icon-check check-component"
    ></i>
    <i
      v-else
      :style="`font-size: ${size};`"
      class="el-icon-close check-component"
    ></i>
  </el-tooltip>
</template>

<style scoped>
.check-component {
  font-weight: 900;
}
.el-icon-check {
  color: #67c23a;
}
.el-icon-close {
  color: #f56c6c;
}
</style>
